<template>
    <div>
        <buttonlist @reflash="reflash" @search="search" @print="print" @del="del" @exps="exps" ref="SetBtn"></buttonlist>
        <div>
            <vxe-table
                    :data="dataSet"
                    v-loading="loading"
                    border
                    resizable
                    size="mini"
                    :height="tableHeight"
                    ref="singleTable"
                    header-row-class-name="headerclass"
                    :header-cell-style="$limits.headerClass"
                    :auto-resize="true"
                    :highlight-current-row="true"
                    show-overflow="tooltip"
                    @cell-click="clickcell"
                    @cell-dblclick="dblclickcell"
                    :row-class-name="setRowClassName"
                    :span-method="handleSpanMethod"
            >
                <vxe-table-column show-overflow field="日期" title="日期" width='80'/>
                <vxe-table-column show-overflow field="凭证类别" title="凭证类别" width='100'/>
                <vxe-table-column show-overflow field="凭证编号" title="凭证编号" width='100'>
                </vxe-table-column>
                <vxe-table-column show-overflow field="审" title="审"  width='50'>
                    <template slot-scope="scope">
                        {{scope.row['审核'] != ''?'v':''}}
                    </template>
                </vxe-table-column>
                <vxe-table-column show-overflow field="记" title="记"  width='50'>
                    <template slot-scope="scope">
                        {{scope.row['记帐'] != ''?'v':''}}
                    </template>
                </vxe-table-column>
                <vxe-table-column show-overflow field="印" title="印"  width='50'>
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row['印']" :true-label="1" :false-label="0"></el-checkbox>
                    </template>
                </vxe-table-column>
                <vxe-table-column show-overflow field="摘要" title="摘要" width='100'/>
                <vxe-table-column show-overflow field="科目编码" title="科目编码" width='100'/>
                <vxe-table-column show-overflow field="科目名称" title="科目名称" width='100'/>
                <vxe-table-column show-overflow field="借方金额" title="借方金额" width='100' align="right"/>
                <vxe-table-column show-overflow field="贷方金额" title="贷方金额" width='100' align="right"/>
                <vxe-table-column show-overflow field="数量" title="数量" width='60' align="right"/>
                <vxe-table-column show-overflow field="单价" title="单价" width='60' align="right"/>
                <vxe-table-column show-overflow field="外币" title="外币"  width='60'/>
                <vxe-table-column show-overflow field="汇率" title="汇率" width='60' align="right"/>
                <vxe-table-column show-overflow field="制单" title="制单"  width='60'/>
                <vxe-table-column show-overflow field="审核" title="审核"  width='60'/>
                <vxe-table-column show-overflow field="记帐" title="记帐"  width='60'/>
                <vxe-table-column show-overflow field="打印" title="打印"  width='60'/>
                <vxe-table-column show-overflow field="单位码1" title="单位码1"  width='80'/>
                <vxe-table-column show-overflow field="单位码1描述" title="单位码1描述"  width='100'/>
                <vxe-table-column show-overflow field="单位码2" title="单位码2"  width='80'/>
                <vxe-table-column show-overflow field="单位码2描述" title="单位码2描述"  width='100'/>
                <vxe-table-column show-overflow field="单位码3" title="单位码3"  width='80'/>
                <vxe-table-column show-overflow field="单位码3描述" title="单位码3描述)"  width='100'/>
                <vxe-table-column show-overflow field="单位码4" title="单位码4"  width='80'/>
                <vxe-table-column show-overflow field="单位码4描述" title="单位码4描述"  width='100'/>
                <vxe-table-column show-overflow field="供货商编码" title="供货商编码"  width='100'/>
                <vxe-table-column show-overflow field="供货商名称" title="供货商名称"  width='100'/>
                <vxe-table-column show-overflow field="客户编码" title="客户编码"  width='100'/>
                <vxe-table-column show-overflow field="客户名称" title="客户名称"  width='100'/>
            </vxe-table>
        </div>

        <el-dialog v-dialogDrag :visible.sync="isVisible" title="查询" width="30%" :close-on-click-modal="false">
            <table>
                <tr>
                    <td>
                        会计年度
                    </td>
                    <td><el-input type="text" size="mini" v-model="sdata.year"></el-input></td>
                </tr>
                <tr>
                    <td>
                        会计期间
                    </td>
                    <td><el-input type="text" size="mini" v-model="sdata.month"></el-input></td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
				<el-button  size="small" @click="isVisible = false">取消</el-button>
				<el-button  size="small" type="primary" @click="getView">确定</el-button>
			    </span>
        </el-dialog>

    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name:'3_vouchbrowerfilter',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                userData: [], // 用户信息
                dataDetail: {},
                currencyList: [],
                rateList: [],
                currency_name: '',
                tax_rate: '',
                sdata:{
                    year:'2025',
                    month:'12',
                },
                isVisible: false,
                dataSet:[],
                loading: false,
                vouchtypearr:[], // 凭证类别数组
                stuffarr:[], // 人员数组
                stuffarr_c:[], //制单人员数组
                stuffarr_a:[], //审核人员数组
                stuffarr_b:[], //记账人员数组
                selectrow:{}, //当前选中行
                rowdata:{ //选中行数据
                    year:'',
                    month:'',
                    vouchtype:'',
                    vouchid:'',
                },
                printVis:false,//打印弹窗
                printData:{
                    printtype:'1',
                    printbyday:'',
                    printbymonth:'',
                    td:'2',
                    printall:'2',
                },
                isSysVouchType:true,//是都为系统凭证
                notSysVTarr:[],//非系统凭证合集
                spanCache: new Map(), // 缓存合并信息 {rowIndex_columnName: {rowspan, colspan}}
                mergeColumns: [
                    '日期', '凭证类别', '凭证编号',
                    '制单', '审核', '记帐',
                    '打印', '审', '记', '印'
                ],
            };
        },
        watch:{
            dataSet: {
                immediate: true,
                handler(newVal) {
                    if (newVal && newVal.length > 0) {
                        this.precomputeSpans();
                    }
                }
            }
        },
        mounted: function() {
            let that = this;
            that.authority();
        },
        methods: {
            //权限
            authority() {
                let that = this;
                if(that.selectrow['凭证编号']){
                    that.$refs.SetBtn.SetButtonEnable('search,del,refresh');
                } else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
            },
            //背景色
            setRowClassName({ row, rowIndex }) {
                let that = this
                if(row['凭证类别'] + row['凭证编号'] == that.selectrow['凭证类别'] + that.selectrow['凭证编号']){
                    return 'currentRow'
                } else {
                    return `group-row-${row.isFirstGroup}`;
                }
            },
            getGroupIndex(group) {
                let that = this
                let index = 0;
                for (let i = 0; i < that.dataSet.length; i++) {
                    if (i > 0 && ((that.dataSet[i]['凭证类别'] + that.dataSet[i]['凭证编号']) !== (that.dataSet[i - 1]['凭证类别'] + that.dataSet[i-1]['凭证编号']))) {
                        index++;
                    }
                    if (that.dataSet[i]['凭证类别'] + that.dataSet[i]['凭证编号'] === group) {
                        return index;
                    }
                }
                return index;
            },
            // 预处理所有合并信息
            precomputeSpans() {
                this.spanCache.clear();
                let currentGroupKey = '';
                let groupStartRowIndex = 0;

                this.dataSet.forEach((row, rowIndex) => {
                    const groupKey = row['凭证类别'] + row['凭证编号'];

                    // 新组开始
                    if (groupKey !== currentGroupKey) {
                        // 处理上一个组的合并
                        if (currentGroupKey) {
                            this.cacheGroupSpans(groupStartRowIndex, rowIndex - 1);
                        }

                        currentGroupKey = groupKey;
                        groupStartRowIndex = rowIndex;
                    }

                    // 最后一行的处理
                    if (rowIndex === this.dataSet.length - 1) {
                        this.cacheGroupSpans(groupStartRowIndex, rowIndex);
                    }
                });
            },

            // 缓存一个组的合并信息
            cacheGroupSpans(startRowIndex, endRowIndex) {
                const rowspan = endRowIndex - startRowIndex + 1;

                this.mergeColumns.forEach(column => {
                    // 组内第一行设置合并行数
                    this.spanCache.set(`${startRowIndex}_${column}`, {
                        rowspan,
                        colspan: 1
                    });

                    // 组内其他行设置为不显示
                    for (let i = startRowIndex + 1; i <= endRowIndex; i++) {
                        this.spanCache.set(`${i}_${column}`, {
                            rowspan: 0,
                            colspan: 0
                        });
                    }
                });
            },

            // 优化后的合并方法
            handleSpanMethod({ row, rowIndex, column }) {
                if (this.mergeColumns.includes(column.property)) {
                    return this.spanCache.get(`${rowIndex}_${column.property}`) ||
                        { rowspan: 1, colspan: 1 };
                }
                return { rowspan: 1, colspan: 1 };
            },
            search(){
                let that = this
                that.isVisible = true
            },
            getView() {
                let that = this;
                let parm = {
                    TYear:that.sdata.year,
                    Month:that.sdata.month
                }
                that.$http.urlpost('GL/Basic/GetVouch', parm, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent
                        for(let i=0;i<that.dataSet.length;i++){
                            if (i === 0 || ((that.dataSet[i]['凭证类别'] + that.dataSet[i]['凭证编号']) !== (that.dataSet[i - 1]['凭证类别'] + that.dataSet[i -1]['凭证编号']))) {
                                // 获取当前组的索引
                                const groupIndex = that.getGroupIndex(that.dataSet[i]['凭证类别'] + that.dataSet[i]['凭证编号']);
                                // 根据组的索引交替设置背景色
                                const colorIndex = groupIndex % 2;
                                that.dataSet[i].isFirstGroup = colorIndex;
                            }
                            // 同一组的其他行继承第一行的样式
                            const groupIndex = that.getGroupIndex(that.dataSet[i]['凭证类别'] + that.dataSet[i]['凭证编号']);
                            const colorIndex = groupIndex % 2;
                            that.dataSet[i].isFirstGroup = colorIndex;
                        }
                        that.selectrow={}
                        that.isVisible = false
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            clickcell({row}){
                let that = this
                that.selectrow = row
                that.authority()
            },
            //双击打开凭证
            dblclickcell({row}){
                let that = this
                let data = {
                    year: row['会计年度'],
                    month: row['会计期间'],
                    vouchtype:row['凭证类别'],
                    vouchid:row['凭证编号'],
                }
                let arr = []
                for(let i=0;i<that.dataSet.length;i++){
                    if(that.dataSet[i]['凭证编号'] == row['凭证编号']){
                        arr = [...arr,that.dataSet[i]]
                    }
                }
                console.log(arr)
                that.$store.commit('setSharedParamsArr',arr);
                let item = {
                    label: '记账凭证',
                    name: 'vouch',
                    path: '/vouch',
                    url: '/vouch',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/vouch' });
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            del(){
                let that = this
                this.$confirm('确定删除数据?', '提示', {//'确定删除数据?'
                    confirmButtonText: '确定',
                    cancelButtonText: '删除',
                    type: 'warning'
                })
                    .then(() => {
                        let str = ''
                        for(let i = 0;i<that.dataSet.length;i++){
                            if(that.selectrow['凭证类别'] + that.selectrow['凭证编号'] == that.dataSet[i]['凭证类别'] + that.dataSet[i]['凭证编号']){
                                str = str + that.dataSet[i]['序号'] + ','
                            }
                        }
                        str = str.substring(0,str.length-1)
                        let parm = {
                            ids: str,
                            LangType:that.$processdata.getLang()
                        }
                        that.$http.urlpost('GL/Basic/DeleteVouchByID', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.selectrow = {}
                                that.getView()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '取消'
                        });
                    });
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /* 定义交替的背景色 */
    /deep/.group-row-0 {
        background-color: #f0f8ff;
    }

    /deep/.group-row-1 {
        background-color: #ffffff;
    }

    /deep/.currentRow {
        background-color: #7ebbf9 !important;
    }
</style>
